import NextLink from 'next/link';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { twJoin } from 'tailwind-merge';

import Icon from 'shopper/components/Icon';

import { sendEvent } from 'lib/gtag';
import trackEvent from 'lib/posthog/trackEvent';
import { stripQs } from 'lib/request';

import HOME_OFFERS_LIST_TABS from 'constants/homeOffersListTabs';

const OffersOptions = forwardRef(
  ({ gaEventCategory, onHideOffersLinkClick }, ref) => {
    const router = useRouter();
    const pathname = stripQs(router.asPath);

    return (
      <div
        ref={ref}
        className="flex w-full items-center gap-4 overflow-x-auto border-b border-neutral-high-200 scrollbar-none dark:border-neutral-low-200 lg:gap-6"
      >
        {HOME_OFFERS_LIST_TABS.map(({ id, title, href }) => {
          const isActive = href === pathname;

          return (
            <NextLink
              key={id}
              href={href}
              prefetch={false}
              scroll={false}
              passHref
            >
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
              <a
                className={twJoin(
                  'whitespace-nowrap border-b-2 pb-2 text-sm transition-colors lg:text-base',
                  isActive
                    ? 'border-primary-300 font-medium text-primary-300'
                    : 'font-normal border-transparent text-neutral-low-300 hover:text-primary-300 dark:text-neutral-high-300 dark:hover:text-primary-200'
                )}
                onClick={() => {
                  sendEvent({
                    action: `sheet_${id}_offers`,
                    category: gaEventCategory,
                  });

                  trackEvent(
                    'click home tab',
                    { event_category: 'home', event_label: id },
                    { destination: 'ga4' }
                  );
                }}
              >
                {title}
              </a>
            </NextLink>
          );
        })}
        <button
          aria-label="Abrir modal de ocultar ofertas"
          className="ml-auto pb-2 text-neutral-low-300 transition-colors hover:text-neutral-low-400 dark:text-neutral-high-300"
          type="button"
          onClick={onHideOffersLinkClick}
        >
          <Icon name="sliders" size="size3" />
        </button>
      </div>
    );
  }
);

OffersOptions.displayName = 'OffersOptions';

OffersOptions.propTypes = {
  gaEventCategory: PropTypes.string,
  onHideOffersLinkClick: PropTypes.func.isRequired,
};

export default OffersOptions;
